export default function SvgNewOnglet() {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          cursor="pointer"
          fill="blue"
          viewBox="0 0 16 16"
        >
          <path d="M4 0v3H1v12h12v-3h3V0zm7.2 13.2H2.8V4.8H4V12h7.2zm3.4-2.6H6.39l5.11-5.1L13 7V3H9l1.5 1.5-5.1 5.11V1.4h9.2z"></path>
        </svg>
      </>
    );
  }
